import BackspaceIcon from '@mui/icons-material/Backspace';
import { Box, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Loader from 'components/Loader';
import BatchRowsModal from 'containers/PosOrderDetailsPage/BatchRowsModal';
import Product from 'containers/PosOrderDetailsPage/Product';

import { InventoryProductItem } from 'types/inventory.interface';
import { POSAddItemToOrderPayload } from 'types/pos.interface';
import { isPartialMatch } from 'utils/search';

import {
  FilterBar,
  FilterInput,
  ProductsListWrapper,
  DeleteButton,
  ProductsWrapper,
} from './index.styled';

interface ProductListProps {
  products: InventoryProductItem[];
  loading: boolean;
  onAddItemToOrderHandler: (payload: POSAddItemToOrderPayload) => void;
}

const ProductsList: FC<ProductListProps> = ({ products, loading, onAddItemToOrderHandler }) => {
  const [searchedItem, setSearchedItem] = useState<string>('');
  const [openItemModal, setOpenItemModal] = useState(false);
  const [productToShow, setProductToShow] = useState<InventoryProductItem | null>(null);
  const [, setSearchParams] = useSearchParams();

  const filteredProducts = products.filter((item) => isPartialMatch(item.itemName, searchedItem));

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchedItem(event.target.value);
  };

  const handleDeleteInput = () => {
    setSearchedItem('');
  };

  const handleOpenItemModal = (item: InventoryProductItem) => {
    setProductToShow(item);
    setOpenItemModal(true);
    setSearchParams({ productId: item.itemId.toString() });
  };

  const handleCloseItemModal = () => {
    setOpenItemModal(false);
    setProductToShow(null);
    setSearchParams({});
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <ProductsWrapper>
      <FilterBar>
        <Typography flex={1}>Filter by Name</Typography>
        <Box display="flex" flex={1}>
          <FilterInput
            variant="outlined"
            value={searchedItem}
            fullWidth
            onChange={handleSearchChange}
          />
          <DeleteButton id="button-deleteFilteredItems" onClick={handleDeleteInput}>
            <BackspaceIcon />
          </DeleteButton>
        </Box>
      </FilterBar>

      <ProductsListWrapper>
        {filteredProducts.map((product) => (
          <Product
            product={product}
            key={product.itemId}
            onClick={handleOpenItemModal}
          />
        ))}
      </ProductsListWrapper>

      {productToShow && (
        <BatchRowsModal
          open={openItemModal}
          onClose={handleCloseItemModal}
          product={productToShow}
          onAddItemToOrderHandler={onAddItemToOrderHandler}
        />
      )}
    </ProductsWrapper>
  );
};

export default ProductsList;
